module.exports = __webpack_public_path__ + "static/media/Orientation Icon.66a75603.png";